import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const requestScenarioCostExport = api(async function requestScenarioCostExport({
    scenarioId,
    variantIds,
    mode,
}) {
    return mutate(
        gql`
            mutation RequestScenarioCostExport($scenarioId: String!, $variantIds: [String!]!, $mode: String!) {
                requestScenarioCostExport(scenarioId: $scenarioId, variantIds: $variantIds, mode: $mode)
            }
        `,
        { scenarioId, variantIds, mode },
        { returns: "requestScenarioCostExport" }
    )
})
